import { z } from "zod"

export const powurOsManufacturerLenderAlias = z.object({
  id: z.number().int(),
  manufacturerId: z.number().int(),
  loanProviderOwnerId: z.number().int(),
  lenderIdentifier: z.string(),
  lenderManufacturerName: z.string(),
  deletedDateTime: z.string().nullable(),
})
export type PowurOsManufacturerLenderAlias = z.infer<
  typeof powurOsManufacturerLenderAlias
>

export const powurOsManufacturerSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  createdById: z.nullable(z.string()),
  createdDateTime: z.string(),
  modifiedById: z.nullable(z.string()),
  modifiedDateTime: z.nullable(z.string()),
  deletedById: z.nullable(z.string()),
  deletedDateTime: z.nullable(z.string()),
  manufacturerLenderAliases: powurOsManufacturerLenderAlias.array(),
})
export type PowurOsManufacturer = z.infer<typeof powurOsManufacturerSchema>
